<aslib-grid #grid id="grid" name="grid" headerTitle="Dados para pagamento" [(dataset)]="listaNaoProcessado" indexColumnVisible="true" limit="10">
  
  <aslib-grid-column  [property]="'id'" [visible]="false"  header="id" class="text-right" [width]="10"
    [sortable]="true" [resizable]="true">
  </aslib-grid-column>

  <aslib-grid-column [property]="'cnpjCpfCredor'" header="CPF/CNPJ do Credor" class="text-right" [width]="175"
  [sortable]="false" [resizable]="true">
  <ng-template #AslibGridCell let-item="item">
    <span *ngIf="item.cnpjCpfCredor">{{item.cnpjCpfCredor | cpf}}</span>
  </ng-template>
  </aslib-grid-column>

  <aslib-grid-column [property]="'nomeCredor'" header="Nome do Credor" class="text-left" [width]="400"
    [sortable]="true" [resizable]="true">
  </aslib-grid-column>

  <aslib-grid-column [property]="'numeroProcessoSEI'" header="Número do Processo SEI" class="text-left" [width]="220"
    [sortable]="true" [resizable]="true">
    <ng-template #AslibGridCell let-item="item">
      <span *ngIf="item.numeroProcessoSEI">{{item.numeroProcessoSEI | processoSei}}</span>
    </ng-template>
  </aslib-grid-column>

  <aslib-grid-column [property]="'numeroEmpenho'" header="Número do EMP" class="text-right" [width]="175"
    [sortable]="true" [resizable]="true">
    <ng-template #AslibGridCell let-item="item">
      <span *ngIf="item.numeroEmpenho">{{item.numeroEmpenho | pedEmpLiq}}</span>
    </ng-template>
  </aslib-grid-column>

  <aslib-grid-column [property]="'mensagemErro'" header="Erro" class="text-left" [width]="325"
    [sortable]="true" [resizable]="true">
  </aslib-grid-column>

  <aslib-grid-column [property]="'reenviada'" header="Reenviada" class="text-center" [width]="90" 
    [sortable]="false" [resizable]="false">
    <ng-template #AslibGridCell let-item="item">
      <div *ngIf="item.reenviada"><span class="badge badge badge-success">Sim</span></div>
      <div *ngIf="!item.reenviada"><span class="badge badge badge-danger">Não</span></div>
    </ng-template>
  </aslib-grid-column>

</aslib-grid>

<div class="form-row">
    <button (click)="reenviarLIQ(grid)" [disabled]="desabilitarReenviar" style="margin-top: 30px;" type="submit"
      class="btn btn-primary" value="Salvar">
      <aslib-icon type="1" icon="fa fa-paper-plane"></aslib-icon>Reenviar
    </button>
</div>  



// WEBPACK FOOTER //
// ./src/app/pagamento/liq-pagamento/liq/nao-processado/nao-processado-liq.component.html